module.exports = __webpack_public_path__ + "5.0.2/img/logo_16.9776e21d.png";